<script setup>
import { computed } from 'vue';
import { useMapGetter } from 'dashboard/composables/store';
import wootConstants from 'dashboard/constants/globals';
import { useI18n } from 'vue-i18n';

import { DropdownSection, DropdownItem } from 'next/dropdown-menu/base';

const { t } = useI18n();
const currentUserAvailability = useMapGetter('getCurrentUserAvailability');

const { AVAILABILITY_STATUS_KEYS } = wootConstants;
const statusMeta = {
  online: { labelKey: 'PROFILE_SETTINGS.FORM.AVAILABILITY.STATUS.ONLINE', color: 'bg-n-teal-9' },
  busy: { labelKey: 'PROFILE_SETTINGS.FORM.AVAILABILITY.STATUS.BUSY', color: 'bg-n-amber-9' },
  offline: { labelKey: 'PROFILE_SETTINGS.FORM.AVAILABILITY.STATUS.OFFLINE', color: 'bg-n-slate-9' },
};

const activeStatus = computed(() => {
  const key = currentUserAvailability.value || AVAILABILITY_STATUS_KEYS[0];
  const meta = statusMeta[key] || statusMeta.online;
  return {
    label: t(meta.labelKey),
    color: meta.color,
  };
});
</script>

<template>
  <DropdownSection>
    <DropdownItem preserve-open>
      <div class="flex-grow flex items-center gap-2">
        <span>{{ $t('SIDEBAR.SET_YOUR_AVAILABILITY') }}</span>
      </div>
      <div
        class="flex items-center gap-1.5 px-2 py-1 rounded-md bg-n-alpha-1 text-sm text-n-slate-11"
      >
        <span class="size-2 rounded-sm flex-shrink-0" :class="activeStatus.color" />
        <span>{{ activeStatus.label }}</span>
      </div>
    </DropdownItem>
  </DropdownSection>
</template>
